'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useActionState, useEffect, useState } from 'react';
import { toast } from 'sonner';

import { AuthForm } from '@/components/auth-form';
import { SubmitButton } from '@/components/submit-button';

import { register, type RegisterActionState } from '../actions';
import { decode, encode, isEn, setLocalStorage } from '@/lib/utils';
import { useDeviceFingerprint } from '@/hooks/useDeviceFingerprint';

export default function Page() {
  const router = useRouter();
  const { deviceId, isLoading } = useDeviceFingerprint();

  const [email, setEmail] = useState('');
  const [isSuccessful, setIsSuccessful] = useState(false);

  const [state, formAction] = useActionState<RegisterActionState, FormData>(
    register,
    {
      status: 'idle',
    },
  );

  useEffect(() => {
    if (state.status === 'user_exists') {
      toast.error(isEn ? 'Account already exists' : '账户已存在');
    } else if (state.status === 'failed') {
      toast.error(isEn ? 'Failed to create account' : '创建账户失败');
    } else if (state.status === 'invalid_data') {
      toast.error(isEn ? 'Failed validating your submission!' : '提交数据验证失败');
    } else if (state.status === 'invalid_code'){
      toast.error(isEn ? 'Failed validating your invitation!' : '邀请码验证失败');
    } else if (state.status === 'success') {
      toast.success(isEn ? 'Account created successfully' : '账户创建成功');
      setIsSuccessful(true);
      router.push('/login');
      router.refresh();
    }
  }, [state, router]); // 添加 isEn 作为依赖项

  const handleSubmit = async (formData: FormData) => {
    const email = formData.get('email') as string;
    const ivc = formData.get('invitationCode') as string;

    // const password = formData.get('password') as string;

    setEmail(email);
    try {
      // 这里继续本地注册
      formAction(formData);
      setLocalStorage('email', email);
      setLocalStorage('ivc', ivc);
    } catch (err: any) {
      toast.error('邀请码验证失败!');
      // setError(err.message || '发生未知错误');
    }
  };

  return (
    <div className="flex h-dvh w-screen items-start pt-12 md:pt-0 md:items-center justify-center bg-background">
      <div className="w-full max-w-md overflow-hidden rounded-2xl gap-12 flex flex-col">
        <div className="flex flex-col items-center justify-center gap-2 px-4 text-center sm:px-16">
          <h3 className="text-xl font-semibold dark:text-zinc-50">{isEn ? 'Sign up' : '注 册'}</h3>
          <p className="text-sm text-gray-500 dark:text-zinc-400">
            {isEn ? 'Create an account with your email and password' : '请输入邮箱和密码'}
          </p>
        </div>
        <AuthForm action={handleSubmit} defaultEmail={email} defaultId={deviceId || undefined} pageName='register'>
          <SubmitButton isSuccessful={isSuccessful}>{isEn ? 'Sign up' : '注 册'}</SubmitButton>
          <p className="text-center text-sm text-gray-600 mt-4 dark:text-zinc-400">
            {isEn ? 'Already have an account? ' : '已经有账号？'}
            <Link
              href="/login"
              className="font-semibold text-gray-800 hover:underline dark:text-zinc-200"
            >
              {isEn ? 'Sign in' : '去 登 录'}
            </Link>
            {isEn ? ' instead.' : ''}

          </p>
        </AuthForm>
      </div>
    </div>
  );
}
